import { apiService } from "../axiosService";

/* -------------------------------------------------------------------------- */
/*                                   APPS                                     */
/* -------------------------------------------------------------------------- */

export const getApplicationsApi = async ({ orgId, signal } = {}) => {
  const response = await apiService.get(`/organisations/${orgId}/apps`, { signal });
  return response;
};

export const createApplicationApi = async ({ orgId, payload }) => {
  const response = await apiService.post(`/organisations/${orgId}/apps`, payload);
  return response;
};

export const updateApplicationApi = async ({ orgId, payload }) => {
  const response = await apiService.put(`/organisations/${orgId}/apps/${payload.id}`, payload);
  return response;
};

export const deleteApplicationApi = async ({ orgId, appId }) => {
  const response = await apiService.delete(`/organisations/${orgId}/apps/${appId}`);
  return response;
};

/* -------------------------------------------------------------------------- */
/*                               APP LOCKS                                    */
/* -------------------------------------------------------------------------- */

export const getApplicationLocksApi = async ({ orgId, signal } = {}) => {
  const response = await apiService.get(`/app-lock/org/${orgId}`, { signal });
  return response;
};

export const lockApplicationApi = async ({ appId }) => {
  const response = await apiService.post(
    `/app-lock`,
    {},
    {
      headers: {
        "Zino-App-Id": appId
      }
    }
  );
  return response;
};

export const unlockApplicationApi = async ({ appId }) => {
  const response = await apiService.delete(`/app-lock`, {
    headers: {
      "Zino-App-Id": appId
    }
  });
  return response;
};

/* -------------------------------------------------------------------------- */
/*                            INFRA / DEPLOY                                  */
/* -------------------------------------------------------------------------- */

export const createInfraApi = async ({ appId, type }) => {
  const url = type === "stage" ? "/application/staging-infra" : "/application/infra";

  const response = await apiService.post(url, null, {
    headers: {
      "Zino-App-Id": appId
    }
  });
  return response;
};

export const deployInfraApi = async ({ appId, type }) => {
  const url = type === "stage" ? "/application/deploy/staging-env" : "/application/deploy/staging";

  const response = await apiService.post(url, null, {
    headers: {
      "Zino-App-Id": appId
    }
  });
  return response;
};

export const destroyInfraApi = async ({ appId, type }) => {
  const url = type === "stage" ? "/application/staging-infra" : "/application/infra";

  const response = await apiService.delete(url, {
    headers: {
      "Zino-App-Id": appId
    }
  });
  return response;
};

/* -------------------------------------------------------------------------- */
/*                                CLONE APP                                   */
/* -------------------------------------------------------------------------- */

export const cloneApplicationApi = async ({ sourceAppId, targetOrgId }) => {
  const response = await apiService.post(`/app/clone/${sourceAppId}/${targetOrgId}`, {});
  return response;
};
